import { dashboardConstants } from "../Sections/constants";

export const setLoading = (data) => async (dispatch) => {
  dispatch({ type: dashboardConstants.SET_LOADING, payload: data });
};

